import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnInit,
  Output,
} from "@angular/core";
import { hasAccess } from "app/access-control/permission-verification";
import { Events, MenuController } from "ionic-angular";
import { Subscription } from "rxjs/Subscription";
import { AccessControlService } from "../../../app/access-control/access-control-service";
import {
  PATIENT_CHART_PAGE,
  VOLUNTEER_MANAGEMENT_PAGE,
} from "../../../app/access-control/common-permission-asks";
import {
  PatientChart as PatientChartEnum,
  VolunteerManagement,
} from "../../../app/access-control/permissions";
import { PermissionsResponse } from "../../../app/access-control/permissions-response";
import { AsmtTypeLookupCode } from "../../../models/assessment/assessment-type";
import { BasePage } from "../../../pages/base-page";
import {
  AppStatus,
  ConnectionStatusEnum,
} from "../../../providers/app-status/app-status";
import { MobileUtilsProvider } from "../../../providers/mobile-utils/mobile-utils";
import { StateManagementService } from "../../../providers/state-management/state-management.service";
import { NavigationService } from "../../navigation.service";
import { NavigationDataService } from "../../services/navigation-data.service";
import { NavData } from "./nav-data";

/**
 * Generated class for the NavigationBarComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "navigation-bar",
  templateUrl: "navigation-bar.html",
})
export class NavigationBarComponent extends BasePage implements OnInit {
  id;
  navConfig: Array<NavData> = [];
  navStatus: object = {};
  activePageId: string;
  idSub: Subscription;
  sectionSub: Subscription;
  dataStateSub: Subscription;
  statusConfigSub: Subscription;
  assessmentType: string;
  userData: any;
  calendarActiveStatus: boolean;
  appSyncStatus: ConnectionStatusEnum;
  connectionStatusEnum = ConnectionStatusEnum;
  isVolunteerAccess: boolean = false;
  permissionsAccess: PermissionsResponse;
  @Output() volunteerAcces = new EventEmitter();
  // private getAccessCntrl$: Subscription;
  clinicalMember: any;
  private currentAssessmentId: string = null;
  private isDestroyed: boolean = false;

  constructor(
    public navData: NavigationDataService,
    public navSvc: NavigationService,
    public stateData: StateManagementService,
    public appStatus: AppStatus,
    public events: Events,
    public mobileUtilsProvider: MobileUtilsProvider,
    public menuCtrl: MenuController,
    private accessCntrl: AccessControlService,
    private cdr: ChangeDetectorRef
  ) {
    super(stateData);

    this.appSyncStatus = this.appStatus.getAppStatus();

    const permissions = [
      ...VOLUNTEER_MANAGEMENT_PAGE,
      ...PATIENT_CHART_PAGE,
      PatientChartEnum.BereavementView,
    ];

    this.accessCntrl.getPermission(permissions).subscribe((data) => {
      this.permissionsAccess = data;
      // this.checkVolunteerActivityAccess(); //need to implement correct way
    });
  }

  updatePreferencesLabelPal1_5 = () => {
    this.navConfig = this.navConfig.map((section: NavData) => {
      if (
        section.id == "preferences" &&
        this.stateData.navigationStatusData.asmtTypeLookupCode !=
          AsmtTypeLookupCode.EVALUATION
      ) {
        section.title = "advCarePlan";
      }
      return section;
    });
  };

  ngOnInit(): void {
    this.idSub = this.stateData.getAssessmentIdObserver().subscribe(
      (data) => {
        if (data === null) {
          this.navConfig = undefined;
        } else if (data !== "0") {
          // Always load navigation config and status when assessment changes
          // Skip loading for assessmentId "0" (used during visit cancellation/cleanup)
          this.loadNavigationConfig();
          this.loadStatusConfig();
        }
      },
      () => {}
    );

    this.assessmentType = this.stateData.getAssessmentType();
    this.stateData.checkUserDisciplines().subscribe(
      (data) => {
        if (data["persons"] && data["persons"].length > 0) {
          this.clinicalMember = data["persons"][0]["teamSet"].length > 0;
        } else {
          this.clinicalMember = false;
        }
      },
      () => {
        this.clinicalMember = false;
      }
    );

    if (
      this.stateData.getAssessmentId() &&
      this.stateData.getAssessmentId() !== "0"
    ) {
      this.loadNavigationConfig();
      this.loadStatusConfig();
    }

    this.dataStateSub = this.stateData
      .getDataStateChangeObserver()
      .subscribe(() => {
        if (this.stateData.getAssessmentId() !== "0") {
          this.loadStatusConfig();
        }
      });

    this.sectionSub = this.stateData
      .getSectionIdObserver()
      .subscribe((data) => {
        this.activePageId = data;
      });

    this.events.subscribe("networkchange", (eventData) => {
      this.appSyncStatus = eventData.status;
    });

    this.stateData.isPatientCalendarToggleOn.subscribe((x) => {
      if (x) {
        this.calendarActiveStatus = x;
      }
    });
  }

  ngOnDestroy() {
    this.isDestroyed = true;
    this.idSub.unsubscribe();
    this.dataStateSub.unsubscribe();
    this.sectionSub.unsubscribe();
    if (this.statusConfigSub) {
      this.statusConfigSub.unsubscribe();
    }
  }

  loadNavigationConfig() {
    this.navData
      .loadNavigationConfig(this.stateData.getAssessmentId())
      .subscribe((data) => {
        this.navConfig = this.sortByKey(data["navData"], "sortOrder");

        this.stateData.showPalliativeV1_5.subscribe((x) => {
          if (x !== null && x) {
            let patientCareType = this.stateData.getPatientCareType();
            if (patientCareType && patientCareType == "Palliative") {
              this.updatePreferencesLabelPal1_5();
            } else {
              this.stateData
                .getPatientCareTypeObserver()
                .subscribe((careType: String) => {
                  if (careType == "Palliative") {
                    this.updatePreferencesLabelPal1_5();
                  }
                });
            }
          }
        });
        this.stateData.setAssessmentType(data["type"]);

        if (
          this.stateData.getSectionId() === null &&
          this.navConfig.length > 0
        ) {
          this.stateData.setSectionId(this.navConfig[0].id);
          this.activePageId = this.stateData.getSectionId();
        } else if (this.stateData.getSectionId()) {
          this.activePageId = this.stateData.getSectionId();
        }
      });
  }

  loadStatusConfig() {
    const assessmentId = this.stateData.getAssessmentId();
    const storageKey = `navStatus_${assessmentId}`;

    // Always try to load from sessionStorage first to prevent flickering
    const storedStatus = sessionStorage.getItem(storageKey);
    if (storedStatus) {
      try {
        this.navStatus = JSON.parse(storedStatus);
      } catch (e) {
        this.navStatus = {};
      }
    } else {
      // Clear navStatus if no cache exists (prevents showing wrong icons)
      this.navStatus = {};
    }

    // Update the current assessment ID
    this.currentAssessmentId = assessmentId;

    // Unsubscribe from previous API call if still pending
    if (this.statusConfigSub) {
      this.statusConfigSub.unsubscribe();
    }

    // Make API call - service will handle caching
    this.statusConfigSub = this.navData
      .loadNavigationStatus(assessmentId)
      .subscribe(
        (data) => {
          sessionStorage.setItem(
            "asmtTypeLookupCode",
            data["asmtTypeLookupCode"]
          );
          // Check if this response is still relevant for the current assessment
          if (this.currentAssessmentId !== assessmentId) {
            // Service already cached this data, so just return without updating component
            return;
          }

          this.stateData.setNavigationStatus(data);
          this.stateData.setNewNavigationStatus(data);

          // Load the parsed status from sessionStorage (service already saved it)
          const storedStatus = sessionStorage.getItem(storageKey);
          if (storedStatus) {
            try {
              this.navStatus = JSON.parse(storedStatus);
            } catch (e) {
              this.navStatus = {};
            }
          }

          // Only trigger change detection if component is still alive
          if (!this.isDestroyed) {
            this.cdr.detectChanges();
          }
        },
        (error) => {
          // If API call fails, keep the sessionStorage value already loaded above
          console.error("Failed to load navigation status:", error);
        }
      );
  }

  onNavClick(id: string) {
    if (this.mobileUtilsProvider.checkIfMobile()) {
      this.menuCtrl.close();
    }
    this.navSvc.goToInternalPage("SectionPage", {
      patChartId: this.stateData.getChartId(),
      assessmentId: this.stateData.getAssessmentId(),
      sectionId: id,
    });
    //sessionStorage.removeItem("asmtStatus");
  }

  redirectPage(id: string) {
    if (id === "CalendarPage") {
      id = "NewCalendarPage";
      this.navSvc.goToInternalPage(id, { patChartId: 0 });
    } else if (id === "CalendarGridView") {
      this.navSvc.goToInternalPage(id, { backToDashboard: true });
    } else {
      this.navSvc.goToInternalPage(id, {});
    }
  }

  isActivePage(page) {
    return page.id == this.activePageId;
  }

  sortByKey(array, key) {
    return array.sort(function (a, b) {
      var x = a[key];
      var y = b[key];
      return x < y ? -1 : x > y ? 1 : 0;
    });
  }

  hasAccessToBereavement() {
    let value = false;
    value = this.stateData.PDB.getValue();
    if (value) {
      value =
        this.permissionsAccess != undefined
          ? hasAccess(
              PatientChartEnum.BereavementView,
              this.permissionsAccess.permissions
            )
          : false;
    }
    return value;
  }

  checkVolunteerActivityAccess() {
    var hasPageAccess =
      this.permissionsAccess != undefined
        ? this.permissionsAccess.permissions.filter(
            (permission) => permission.name == VOLUNTEER_MANAGEMENT_PAGE[0]
          )
        : null;

    if (hasPageAccess != null && hasPageAccess.length > 0) {
      if (!hasPageAccess[0].access) {
        setTimeout(() => {
          this.navSvc.goToInternalPage("AccessDeniedPage", {});
        }, 0);
      }
    }

    let isVolunteerAdmin =
      this.permissionsAccess != undefined
        ? hasAccess(
            VolunteerManagement.VMPAdministrator,
            this.permissionsAccess.permissions
          )
        : false;
    let isVolunteer =
      this.permissionsAccess != undefined
        ? hasAccess(
            VolunteerManagement.VMPVolunteer,
            this.permissionsAccess.permissions
          )
        : false;
    let vmRbac = { voladmin: isVolunteerAdmin, volunteer: isVolunteer };
    this.volunteerAcces.emit(vmRbac);
    this.isVolunteerAccess = isVolunteer || isVolunteerAdmin;
    if (this.mobileUtilsProvider.checkIfMobile()) {
      this.accessCntrl.setVolunteerAccessData(vmRbac);
    }
  }
}



// WEBPACK FOOTER //
// ./src/navigation/components/navigation-bar/navigation-bar.ts